/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { Outlet } from 'react-router-dom';

import AmbientCommandIntelligenceRouteSync from './AmbientCommandIntelligenceRouteSync.jsx';

const AmbientCommandIntelligenceRouteSyncOutlet = () => {
  return (
    <>
      <AmbientCommandIntelligenceRouteSync />
      <Outlet />
    </>
  );
};

export default AmbientCommandIntelligenceRouteSyncOutlet;
